import api from '@/api';
import { API_BASE_URL } from '../../..';
import { QuestReportInvoiceRequest } from '../../../Reports/Invoice/Invoice.types';

const CONTROLLER_URL = `${API_BASE_URL}/Csv`;

export async function getQuestReportCsvInvoice(
  params: QuestReportInvoiceRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/Invoice`,
    params,
  )) as unknown;

  return result as BlobPart;
}
